
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Outlet, Form } from '@/models/Outlet';
import http from '@/services/Http';

declare var grecaptcha: any;

@Component
export default class OutletContactForm extends Vue {
    protected form: Form;
    @Prop() private outlet!: Outlet;
    private showForm: boolean = true;
    private errorMsg: string = '';

    constructor() {
        super();
        this.form = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            name: this.outlet.Name,
            url: this.outlet.Url,
            id: this.outlet.Retailer.Id,
            token: ''
        };
    }

    private submitForm() {
        this.errorMsg = '';
        const recaptchaSiteKey = (window as any).__litium.recaptchaSiteKey as string;

        if (!this.validateForm()) {
            return;
        } else {
            const submit = this.submit;
            grecaptcha.ready(() => {
                grecaptcha
                    .execute(recaptchaSiteKey, {
                        action: 'submit'
                    })
                    .then((token: string) => {
                        submit(token);
                    });
            });
        }
    }

    private submit(token: string) {
        this.form.token = token;

        const contactForm = http.post(`/api/contactform/outlet`, this.form);
        contactForm.then((response: any) => {
            this.showForm = false;
        });
    }

    private validateForm(): boolean {
        const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        if (this.form.email === '') {
            this.errorMsg = 'site.contactform.missingemail';
            return false;
        }
        if (!reg.test(this.form.email)) {
            this.errorMsg = 'site.contactform.emailincorrect';
            return false;
        }
        if (this.form.firstName === '') {
            this.errorMsg = 'site.contactform.missingfirstname';
            return false;
        }
        if (this.form.lastName === '') {
            this.errorMsg = 'site.contactform.missinglastname';
            return false;
        }
        if (this.form.phone === '') {
            this.errorMsg = 'site.contactform.missingphone';
            return false;
        }
        return true;
    }
}
